// extracted by mini-css-extract-plugin
export default {"actions":"ValueChainMapTableHead_actions__EiHhu"};